const googleDriveMutationKeys = {
  createGoogleDriveMirror: () => [
    "create-google-drive-mirror"
  ],
  deleteGoogleDriveMirror: () => [
    "delete-google-drive-mirror"
  ]
};

export { googleDriveMutationKeys };
//# sourceMappingURL=googleDriveMutationKeys.js.map
